define("weak-json", {
    _included: {},
    load: function(name, req, onload, config) {

        var root = "/";
        if ( config.baseUrl ) {
            root = config.baseUrl;
        }

        var path = name.indexOf("/") === 0 ? name : root + name;
        if ( !/\.json$/.test(path) ) {
            path = path + ".json";
        }
        if( this._included[path] ) {
            onload(this._included[path]);
            return;
        }


        const xhr = new XMLHttpRequest();
        xhr.open("GET", path);

        xhr.onreadystatechange = () => {
            if ( xhr.readyState != 4 ) {
                return;
            }

            let json = {};

            if ( xhr.status === 200 ) {
                try {
                    json = JSON.parse( xhr.responseText );
                } catch(err) {}   
            }

            this._included[path] = json;
            onload( json );
        };

        xhr.send();
    }
});
